import Wrapper from './styles';
import React, { useState } from 'react';
import { Title, Content, Label, SliderContainer } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import dataJson from 'shared/data';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import { Select } from './styles';
import { setFilter } from 'redux/general/actions';

const FilterEdo = () => {
  const [st, setSt] = useState('*');
  const dispatch = useDispatch();
  
  const onChange = (e) => {
    const v = e.target.value;
    setSt(v);
    dispatch(setFilter('state', v, true));
  }


  let edos = [];

  const edosKeys = {};

  dataJson.map((d) => {
    const s = d.status;
    if(!edosKeys[s]){
      edos.push({
        name: s,
        value: s
      })
      edosKeys[s] = 1; 
    }
  })

  edos = edos.sort((a, b) => {
    return a.name > b.name ? 1 : -1;
  })

  edos = [{name: 'Todos los estados', value: '*'}, ...edos];


  return(
    <Wrapper>
      <Title>Estado</Title>
      <Content>
        <Select value={st} onChange={onChange}>
          {
            edos.map((edo) => {
              return(
                <option value={edo.value}>{edo.name}</option>
              )
            })
          }
        </Select>
      </Content>
    </Wrapper>
  )
}

export default FilterEdo;